import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isSome } from 'fp-ts/Option';
import { redirectUrlSelector } from 'src/state/auth/authSelectors';
import { PostRedirectAction } from 'src/config/postRedirectAction';
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn';
import { CourseBundleDTO, CourseBundleUserEnrollmentStatus } from 'src/common/models/courseBundle';
import { useCourseBundleSignInMutation } from 'src/common/hooks/courseBundle/useCourseBundleSignInMutation';

interface useJoinCourseBundleAfterRedirectProps {
  courseBundle: CourseBundleDTO | undefined;
  enrollmentStatus: CourseBundleUserEnrollmentStatus | undefined;
}

export const useJoinCourseBundleAfterRedirect = ({
  courseBundle,
  enrollmentStatus,
}: useJoinCourseBundleAfterRedirectProps) => {
  const redirectUrl = useSelector(redirectUrlSelector);
  const { isLoggedIn } = useIsLoggedIn();
  const { mutate, isLoading } = useCourseBundleSignInMutation();

  useEffect(() => {
    if (
      isLoggedIn &&
      isSome(redirectUrl) &&
      PostRedirectAction.JoinCourseBundle === redirectUrl.value.action &&
      courseBundle &&
      enrollmentStatus === CourseBundleUserEnrollmentStatus.NotEnrolled
    ) {
      mutate(courseBundle?.id);
    }
  }, [redirectUrl, isLoggedIn, courseBundle, enrollmentStatus]);

  return { isLoading };
};
